import script from "./PageLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./PageLayout.vue?vue&type=script&setup=true&lang=js"

import "./PageLayout.vue?vue&type=style&index=0&id=18f4c297&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18f4c297"]])

export default __exports__